<template>
  <div :class="$style.container">
    <!-- Основная информация о проекте -->
    <project-information
      :project="project"
      :graph="graph"
    >
      <!-- График транзакций для десктопов -->
      <transaction-chart
        v-if="graph.length > 0"
        slot="graph"
        :data="graph"
      ></transaction-chart>
    </project-information>
    <!-- Доступно для персональных проектов -->
    <template v-if="isPersonalProject">
      <!-- Механизмы управления проектом -->
      <project-control
        v-m-x="20"
        v-m-y="20"
        :project="project"
      ></project-control>

      <responsive-controller>
        <template #laptop>
          <!-- Функциональные баннеры -->
          <div :class="$style.carusel">
            <functional-banners-carusel></functional-banners-carusel>
          </div>
        </template>
        <template #default>
          <div></div>
        </template>
      </responsive-controller>
    </template>
  </div>
</template>

<script>
import ProjectService from 'services/project';

import ProjectControl from 'organisms/project/ProjectControl';
import FunctionalBannersCarusel from 'organisms/project/FunctionalBannersCarusel';
import ProjectInformation from 'templates/project/desktop/ProjectInformationDesktopTemplate';

import TransactionChart from '@/plugins/capusta_chart/chart';

export default {
  name: 'ProjectDashboardDesktopTemplate',
  components: {
    ProjectControl,
    FunctionalBannersCarusel,
    ProjectInformation,
    TransactionChart,
  },
  props: {
    project: {
      type: Object,
      required: true,
    },
    graph: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    isPersonalProject() {
      return ProjectService.checkPersonalProject(this.project);
    },
  },
};
</script>

<style lang="sass" module>
  .container
    position: relative

  .graph
    height: 0
    opacity: 0
    visibility: hidden
    transition: .1s ease

    &.visible
      height: auto
      opacity: 1
      visibility: visible

  .carusel
    margin: 0 20px

    +respond-to('small')
      margin: 0
</style>
